import { useCatalogStore } from '@/infrastructure/store/catalogStore';

export const useCatalog = () => {
  const store = useCatalogStore();
  return {
    categories: store.categories,
    currentCategory: store.currentCategory,
    currentSubcategory: store.currentSubcategory,
    isLoading: store.isLoading,
    error: store.error,
    fetchCategories: store.fetchCategories,
    fetchCategory: store.fetchCategory,
    fetchSubcategory: store.fetchSubcategory,
    clearCurrentCategory: store.clearCurrentCategory,
    clearCurrentSubcategory: store.clearCurrentSubcategory,
  };
};
